import { forwardRef, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import styles from '@app/index.module.css';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { createInternalAPI } from '@config/axiosConfig';
import { responseFile } from '@features/ResponseFile';

export const ExportToCSVButton = ({ to, filterData, size = 'sm' }) => {
  const internalAPI = createInternalAPI();
  const [loading, setLoading] = useState(false);
  return (
    <Button
      variant="didxl"
      size={size}
      disabled={loading}
      onClick={() => {
        setLoading(true);
        internalAPI
          .get(to, {
            params: { ...filterData, _export: 'csv' },
            responseType: 'blob',
          })
          .catch(() => setLoading(false))
          .then((response) =>
            responseFile({
              data: response.data,
              format: 'csv',
              onRequestEnd: setLoading(false),
            })
          );
      }}
    >
      Export to CSV {loading ? <DefaultSpinnerCenter /> : null}
    </Button>
  );
};

export const CustomToggleButton = forwardRef(({ children, onClick }, ref) => (
  <Button
    size="sm"
    variant="outline-secondary"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </Button>
));

export const ButtonSplitGroup = ({ children }) => (
  <div className={styles.splitBtnGroup}>{children}</div>
);

export const ButtonVerticalGroup = ({ children }) =>
  children.map((child) => (
    <Row className="mb-1">
      <Col>{child}</Col>
    </Row>
  ));
